

function getAssetPreviewProps({ asset }) {
  const { loadedPercent, assetId, assetFiles: { ORIGINAL } } = asset;

  return {
    ...(loadedPercent !== void 0 || !ORIGINAL || ORIGINAL.status === 'IN_PROGRESS' ? { assetId } : { asset })
  };
}

export default getAssetPreviewProps;